import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNeedBounding } from '../../../features/map/mapSlice';
import { findLatLngSelector } from '../../../features/map/mapSlice';

const GoogleFindLatLngBounder = ({ map }) => {
    const dispatch = useDispatch();
    const markerData = useSelector(findLatLngSelector);

    useEffect(() => {
        const mapBounder = () => {
            if (map && markerData) {
                if (markerData.lat && markerData.lng) {
                    let bounds = new window.google.maps.LatLngBounds();
                    let point = new window.google.maps.LatLng(
                        parseFloat(markerData.lat), parseFloat(markerData.lng)
                    );
                    bounds.extend(point);
                    map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                    dispatch(setNeedBounding(false));
                }
            }
        };
        mapBounder();
    }, [markerData, dispatch, map]);

    return (
        <div></div>
    );
}

export default GoogleFindLatLngBounder;